import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Typography } from 'builder/styles/typography'
import BaseButton from 'builder/components/Button'
import Media from 'builder/styles/media'
import Badges from 'builder/components/Badges'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${Media.Phone`
    padding-top: 20px;
  `}
`

export const TitleContainer = styled.div`
  width: 100%;

  ${Media.Phone`
    padding: 0 20px 0;
  `}
`

export const Title = styled.div`
  ${Typography.XL};
  color: ${Colors.Blue50};
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
  user-select: none;

  ${Media.Tablet`
    margin-bottom: 24px;
  `}

  ${Media.Phone`
    ${Typography.S};
    margin-bottom: 12px;
  `}
`

export const Subtitle = styled.div`
  text-align: center;
  margin-bottom: 18px;
  user-select: none;

  ${Media.Tablet`
    display: none;
  `}
`

export const TemplatePreviewContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

export const TemplatePreview = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: ${Colors.White};
  transition: transform 0.3s ease, box-shadow 0.4s ease;
  z-index: 1;
`

export const TemplatePreviewWhite = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 8px;
  background-color: ${Colors.White};
  border: 0;
  z-index: 1;
`

export const ClickableArea = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform: scale(1.05);
  left: 0;
  top: 0;
  display: none;
  z-index: 2;
`
export const Button = styled(BaseButton)(({ visible }) => {
  return css`
    display: ${visible ? 'block' : 'none'};
    z-index: 3;
  `
})

export const TemplatesContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  user-select: none;
`

export const TemplateNameContainer = styled.div`
  position: absolute;
  width: auto;
  top: -52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
  transition: transform 0.3s;

  ${Media.Phone`
    top: -38px;
  `}
`
export const TemplateName = styled.div`
  display: flex;
  align-items: center;
`

export const TemplateNameText = styled.div`
  font-weight: 600;

  ${Media.Phone`
    ${Typography.Caption};
  `}
`

export const TemplateNameLink = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 23px;
  z-index: 15;
  font-weight: 600;
  &: hover {
    color: var(--Blue-Blue-50, #1a91f0);
  }
  ${Media.Phone`
    ${Typography.Caption};
  `}
`

export const TemplateBadge = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 4px;
  background-image: url(${require(`images/builder/sign-up/crown.svg`)});
  background-size: contain;
  z-index: 999;
  cursor: pointer;

  ${Media.Phone`
    display: none;
  `}
`

export const TemplateUsageNumber = styled.div`
  ${Typography.Tiny};
  color: ${Colors.Neutral50};
`

export const PlanBadges = styled(Badges).attrs({ topic: 'plan' })`
  position: absolute;
  bottom: 16px;
  left: 16px;
  transition: transform 0.3s;
  z-index: 1;
`

export const FormatBadges = styled(Badges)`
  position: absolute;
  bottom: 16px;
  right: 16px;
  transition: transform 0.3s;
  z-index: 1;
`

export const TemplatesContainer = styled.div`
  position: relative;

  *:focus {
    outline: 0;
    outline: none;
  }

  .slick-current ${FormatBadges} {
    transform: translate(
      ${props => props.badgesHorizontalMargin}px,
      ${props => props.badgesVerticalMargin}px
    );
  }

  .slick-current ${PlanBadges} {
    transform: translate(
      ${props => -props.badgesHorizontalMargin}px,
      ${props => props.badgesVerticalMargin}px
    );
  }

  .slick-current ${TemplateNameContainer} {
    transform: translateY(-12px);
  }

  .slick-current ${TemplatePreview} {
    transform: scale(1.04);
    box-shadow: 0px 20px 40px -8px rgba(186, 200, 227, 0.2),
      0px 12px 24px -8px rgba(186, 200, 227, 0.3);
  }

  .slick-current ${TemplatePreviewWhite} {
    transform: scale(1.04);
    box-shadow: 0px 20px 40px -8px rgba(186, 200, 227, 0.2),
      0px 12px 24px -8px rgba(186, 200, 227, 0.3);
  }

  .slick-current {
    & ${ClickableArea} {
      display: block;
    }

    ${Media.Phone`
      transform: scale(1);
    `};

    ${Button} {
      display: block;
    }
  }
`

export const Template = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => `${height}px`};
  border-radius: 4px;
  flex-shrink: 0;
  cursor: pointer;
  margin: 70px 16px 40px;

  ${Media.Tablet`
    margin: 60px 12px 40px;
  `};

  ${Media.Phone`
    margin: 60px 8px 40px;
  `};
`

const TemplatesButton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${Colors.Blue50};
  color: ${Colors.White};
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${Colors.Blue70};
  }

  ${Media.Phone`
    display: none;
  `}
`

export const TemplatesLeftButton = styled(TemplatesButton)`
  left: 60px;
  top: calc(50% - 24px);
  transform: rotate(180deg);

  ${Media.Tablet`
    left: 24px;
  `}
`

export const TemplatesRightButton = styled(TemplatesButton)`
  right: 60px;
  top: calc(50% - 24px);

  ${Media.Tablet`
    right: 24px;
  `}
`

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const ProgressBarWrapper = styled.div`
  width: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;

  ${Media.Tablet`
    display: flex;
  `}
`

export const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 184px;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.desktopColumns}, 1fr);
  gap: 32px;
  padding: 32px;
  ${Media.Phone`
    grid-template-columns: repeat(${props => props.mobileColumns}, 1fr);
    gap: 20px;
    padding: 20px;
  `}
`

export const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 20px;
  margin: 20px auto;
  gap: 4px;
  ${Media.Phone`
    padding: 10px 20px;
    margin: 0;
  `}
  ::-webkit-scrollbar {
    display: none;
  }
`

export const Category = styled.a`
  flex: 0 0 auto;
  padding: 8px 16px;
  text-align: center;
  gap: 8px;
  border-radius: 36px;
  background: var(--Neutral-Neutral-5, #f7f9fc);
  color: var(--Neutral-Neutral-90, #1e2532);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border: 1px solid transparent;
  cursor: pointer;
  &:hover {
    border-radius: 36px;
    border: 1px solid var(--Blue-Blue-50, #1a91f0);
    background: var(--Blue-Blue-10, #eaf6ff);
    color: var(--Blue-Blue-50, #1a91f0);
  }
  ${props =>
    props.isActive &&
    css`
      border-radius: 36px;
      border: 1px solid var(--Blue-Blue-50, #1a91f0);
      background: var(--Blue-Blue-10, #eaf6ff);
      color: var(--Blue-Blue-50, #1a91f0);
    `}
`

export const TemplateItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  &: hover {
    button {
      display: block;
    }
  }
`

export const TemplateImagePreview = styled.img`
  width: 100%;
  height: 100%;
  box-shadow: 0px 8px 36px 0px #98b4ea30;
  border-radius: 10px;
`

export const TemplateDetailsBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  gap: 5px;
  ${Media.Phone`
    flex-wrap: wrap;
    flex-direction: column;
  `}
`

export const TemplateBadges = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`

export const TemplateColorsPallette = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  z-index: 15;
`

export const TemplateColor = styled.div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  /* border: 1px solid rgba(0, 0, 0, 0.1); */
  box-shadow: inset 0 0 0 4px rgba(0, 0, 0, 0);
  background: ${props => props.color};
  border-radius: 50%;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  &:hover {
    transform: scale(1.125);
    box-shadow: inset 0 0 0 4px rgba(0, 0, 0, 0.1);
    background: white;
    border: 3px solid ${props => props.color};
  }
  ${props =>
    props.default &&
    css`
      transform: scale(1.125);
      box-shadow: inset 0 0 0 4px rgba(0, 0, 0, 0.1);
      background: white;
      border: 3px solid ${props.color};
    `}
`

export const CategoryToggle = styled.div`
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  color: var(--Blue-Blue-50, #1a91f0);
  padding: 8px 16px;
  flex: 0 0 auto;
`

export const HeaderTitle = styled.h2`
  display: none;
  color: var(--Blue-Blue-50, #1a91f0);
  text-align: center;
  /* [Mobile]/M */
  font-size: 27px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 111.111% */
  margin: 10px auto;
  ${Media.Phone`
    display: block;
  `}
`

export const PickButtonContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0px;
  z-index: 10;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const MonochromeIcon = styled.div`
  margin-right: 8px;
  width: 16px;
  height: 16px;
  padding: 2px;
  border: 2px solid var(--neutral-90);
  border-radius: 50%;

  &:after {
    content: '';
    display: block;
    width: 4px;
    height: 8px;
    background-color: var(--neutral-90);
    border-radius: 4px 0 0 4px;
  }
`

export const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
`

export const TemplatesWrapper = styled.div`
  .swiper-container {
    position: relative;
    overflow: visible;
  }

  .swiper-wrapper {
    display: flex;
    position: relative;
    transition-property: transform;
    align-items: flex-end;
  }

  .swiper-slide {
    width: auto;
  }
`

export const TemplatePreviewMobile = styled.div`
  position: relative;
  width: 326px;
  height: 459px;
  background-color: ${Colors.White};
  background-image: ${({ image }) => (image ? `url(${image})` : 'none')};
  background-size: contain;
  transform: ${({ isActive }) => (isActive ? 'scale(1.05)' : 'scale(1)')};
  margin: 16px 4px 8px;
`

export const TemplateSelectionMobileContainer = styled.div`
  height: 100%;
  margin: 48px 0 24px;
`

export const ClickableAreaMobile = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform: scale(1.05);
  left: 0;
  top: 0;
  z-index: 2;
`

export const ButtonMobile = styled(BaseButton)`
  z-index: 3;
  top: 50%;
  left: 25%;
`

// sticky container for the ab test
export const StickyCategoryContainer = styled.div(({ visible }) => {
  return css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    display: ${visible ? 'flex' : 'none'};
    z-index: 999;
  `
})
